import { Box, Skeleton } from '@mui/material'
import { APIError } from 'components/core/errors/api'
import { GetStepUpTransactionRequest } from 'pbts/c1/api/stepup/v1/stepup'
import { FC } from 'react'
import { getStepUpTransactionApi } from 'redux_toolkit/step-up-transactions'
import { StepUpTransactionDisplay, StepUpTransactionDisplayProps } from './StepUpTransactionDisplay'

/**
 * Props for the StepUpTransactionFetcher component
 */
export interface StepUpTransactionFetcherProps extends Omit<StepUpTransactionDisplayProps, 'transaction'> {
    /**
     * The ID of the step-up transaction to fetch
     */
    transactionId: string
}

/**
 * Fetches and displays a step-up transaction
 */
export const StepUpTransactionFetcher: FC<StepUpTransactionFetcherProps> = ({
    transactionId,
    ...displayProps
}) => {
    const { data: response, error, isLoading } = getStepUpTransactionApi.useGet(
        GetStepUpTransactionRequest.create({
            id: transactionId,
        }),
    )

    if (isLoading) {
        return <Skeleton variant="rectangular" width="100%" height={60} />
    }

    if (error) {
        return <APIError err={error} />
    }

    if (!response?.transaction) {
        return (
            <Box sx={{ color: 'text.secondary' }}>
                Transaction not found
            </Box>
        )
    }

    return <StepUpTransactionDisplay transaction={response.transaction} {...displayProps} />
}
